import React from 'react';
import '../css/ContactPage.css';
import ContactSection from './ContactSection';

const ContactPage: React.FC = () => {
  return (
    <div className="contact-page">
      <ContactSection />
    </div>
  );
};

export default ContactPage;